module.exports = __webpack_public_path__ + "static/media/landinglogo.b62d7306.svg";